import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { Spinner } from '../../../Spinner/Spinner.esm.js';
import { resolveSizes } from '../../utils/resolveSizes.esm.js';
import buttonContentStyles from './ButtonContent.styles.esm.js';

const ButtonContent = ({ children, isLoading, loadingMessage, size, icon, iconPosition, hasIcon, inverse, variant, }) => {
    const { baseSize, smSize, mdSize, lgSize } = resolveSizes(size);
    const classes = buttonContentStyles({
        size: baseSize,
        smSize,
        mdSize,
        lgSize,
        inverse,
        variant,
    });
    if (isLoading) {
        return (jsx(Spinner, { size: size, inverse: inverse, arcClassName: classes.spinnerArc(), message: loadingMessage, "aria-hidden": true }));
    }
    const showIcon = (hasIcon !== null && hasIcon !== void 0 ? hasIcon : !!icon) && !!icon;
    if (!showIcon)
        return jsx(Fragment, { children: children });
    const iconEl = jsx("span", { className: classes.icon(), children: icon });
    return (jsxs(Fragment, { children: [iconPosition === "left" ? iconEl : null, children, iconPosition === "right" ? iconEl : null] }));
};

export { ButtonContent };
